import { Flex } from "@chakra-ui/layout";
import { StyleProps } from "@chakra-ui/react";
import { ReactNode } from "react";

interface ColumnTitleProps extends StyleProps {
    children: ReactNode;
}

export const ColumnTitle = (props: ColumnTitleProps) => {
    const { color, children, display, pt = "5", marginBottom, width, visibility } = props;

    return (
        <Flex
            display={display}
            direction="row"
            width={width}
            pt={pt}
            marginBottom={marginBottom}
            color={color}
            fontWeight="500"
            visibility={visibility}
        >
            {children}
        </Flex>
    );
}